import {
  customStyle,
  styleEnd,
  styleStart,
} from "../../algorithms/styleDirection";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import { Link } from "react-router-dom";
import "moment/locale/ar";
import Lang from "../../userPreferences/staticWords";
import { useEffect, useState } from "react";
import ModalComponent from "../reusableComponents/modal";

import { formatDateLL } from "./../../algorithms/index";

import { getEditDataTaskForm } from "../../API/store/actions/tasks";
import { resolver } from "../../API/middlewares/resolveRequests";
import { useSelector } from "react-redux";
import DeleteProcAlert from "../tasks/editProc.js/deleteProc";
import EditNotification from "./editNotification";
import {
  getDataNotificationForm,
  getEditDataNotificationForm,
} from "./../../API/store/actions/sharek";
import ReactTooltip from "react-tooltip";

const NotifIcationCard = ({
  setProcAdded,
  procAdded,
  userToken,
  communityId,
  Notifications,
}) => {
  const [show, setshow] = useState({ id: null, display: false });
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [notificationId, setNotificationId] = useState(null);
  const [NotificationTitle, setTaskTitle] = useState(null);
  const community = useSelector((state) => state.community.communityId);

  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [resendModalVisible, setResendModalVisible] = useState(false);

  const [data, setData] = useState(null);
  useEffect(() => {
    if (data) setVisibleEdit(true);
  }, [data]);

  document.onclick = function (event) {
    if (
      !event.target.matches(".icon") &&
      !event.target.matches(".icon svg path")
    ) {
      var sharedowns = document.getElementsByClassName(
        `${customStyle("dropdown-menu")}`
      );
      for (let i = 0; i < sharedowns?.length; i++) {
        var openSharedown = sharedowns[i];
        if (openSharedown?.classList?.contains("show")) {
          openSharedown?.classList?.remove("show");
          setshow({ id: null, display: false });
        }
      }
    }
  };

  const [formMembers, setFormMembers] = useState([]);
  const [membersList, setMembersList] = useState([]);

  useEffect(() => {
    resolver(getDataNotificationForm, setFormMembers, userToken);
  }, []);

  const userLogged = useSelector((state) => state.login.userData);

  if (Notifications?.data) {
    return (
      <>
        <ModalComponent
          body={
            <EditNotification
              membersList={membersList}
              setMembersList={setMembersList}
              NotificationTitle={NotificationTitle}
              notificationId={notificationId}
              setVisible={setVisibleEdit}
              data={data?.data}
              formMembers={formMembers}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
              userToken={userToken}
              communityId={communityId}
            />
          }
          hasImage={
            <img
              src="/assets/images/greeniconedit.svg"
              width={20}
              height={20}
              alt=""
            />
          }
          setModalVisible={setVisibleEdit}
          modalVisible={visibleEdit}
          size={"xl"}
          title={"تعديل الإشعار"}
        />

        <ModalComponent
          body={
            <DeleteProcAlert
              userToken={userToken}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
              notificationId={notificationId}
              setVisible={setDeleteModalVisible}
              content={"هل تريد حذف الإشعار"}
            />
          }
          size={"s"}
          modalVisible={deleteModalVisible}
          setModalVisible={setDeleteModalVisible}
          hasImage={
            <img
              src="/assets/images/deleteicon.png"
              width={20}
              height={20}
              alt=""
            />
          }
          title={"هل انت متاكد"}
          background={"modalBackground mx-5"}
        />
        <ModalComponent
          body={
            <DeleteProcAlert
              userToken={userToken}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
              resendNotificationId={notificationId}
              setVisible={setResendModalVisible}
              content={"هل تريد إعادة إرسال الإشعار مرة أخرى"}
            />
          }
          size={"s"}
          modalVisible={resendModalVisible}
          setModalVisible={setResendModalVisible}
          hasImage={
            <img
              src="/assets/images/icons/bell (1).png"
              width={20}
              height={20}
              alt=""
            />
          }
          title={"هل انت متاكد"}
          background={"modalBackground mx-5"}
        />
        <div
          className={`d-flex flex-column align-self-center col-lg-8 col-10 ${styleStart(
            "m",
            4,
            "lg"
          )} mx-0`}
        >
          {Notifications?.data?.map((item, index) => {
            return (
              <div
                className="d-flex flex-column col-12 mt-4 taskCard"
                style={{
                  border: "1px solid #C7C7C9",
                  borderRadius: 10,
                  height: "fit-content",
                }}
                key={item.id}
              >
                {/* title */}
                <div className="d-flex align-items-start px-4 py-3">
                  {item.name ? (
                    <div
                      className={`my-0 ${styleEnd(
                        "m",
                        3
                      )} text-decoration-none text-dark`}
                      style={{
                        lineHeight: 1.5,
                        fontSize: 20,
                        fontWeight: "bold",
                      }}
                      // to={`/taskDetails/${item.id}`}
                    >
                      {item.name}
                    </div>
                  ) : null}

                  <div className="col d-flex justify-content-end align-items-start btn-group">
                    {show.id == item.id ? (
                      <>
                        <div
                          style={{ display: show.display ? "block" : "none" }}
                          className={`${customStyle("arrow-horizontal")} ${
                            show.display ? "show" : ""
                          }`}
                        ></div>
                        <ul
                          className={`${customStyle("dropdown-menu")} ${
                            show.display ? "show" : ""
                          }`}
                          style={{
                            display: show.display ? "block" : "none",
                          }}
                        >
                          <li
                            style={{ cursor: "pointer" }}
                            id={item.id}
                            onClick={(e) => {
                              const currentId = e.currentTarget.id;
                              resolver(
                                getEditDataNotificationForm,
                                setData,
                                currentId,
                                userToken
                              );
                              setNotificationId(currentId);
                            }}
                          >
                            <span
                              className={`dropdown-item ${customStyle(
                                "dropdown-item"
                              )}`}
                            >
                              تعديل الإشعار
                            </span>
                          </li>
                          <li
                            style={{ cursor: "pointer" }}
                            id={item.id}
                            onClick={(e) => {
                              const currentId = e.currentTarget.id;
                              setNotificationId(currentId);
                              setDeleteModalVisible(true);
                            }}
                          >
                            <span
                              className={`dropdown-item ${customStyle(
                                "dropdown-item"
                              )}`}
                            >
                              حذف الإشعار
                            </span>
                          </li>
                          <li
                            style={{ cursor: "pointer" }}
                            id={item.id}
                            onClick={(e) => {
                              const currentId = e.currentTarget.id;
                              setNotificationId(currentId);
                              setResendModalVisible(true);
                            }}
                          >
                            <span
                              className={`dropdown-item ${customStyle(
                                "dropdown-item"
                              )}`}
                            >
                              إعادة إرسال
                            </span>
                          </li>
                        </ul>
                      </>
                    ) : null}
                  </div>

                  {userLogged?.isAdmin && (
                    <Icon
                      id={item.id}
                      name="ellipsis-v"
                      size={18}
                      className="icon"
                      onclick={(e) => {
                        const id = e.currentTarget.id;
                        id == null
                          ? setshow({
                              id,
                              display: true,
                            })
                          : id == show.id
                          ? setshow({
                              id: null,
                              display: false,
                            })
                          : setshow({
                              id,
                              display: true,
                            });
                      }}
                    />
                  )}
                </div>

                {/* date */}
                {item.createDate && (
                  <div className="d-flex align-items-center px-4">
                    <p className="text-muted" style={{ fontSize: 14 }}>
                      {"التاريخ"}
                      <span>
                        &nbsp;
                        {`${formatDateLL(item.createDate)}`}
                      </span>
                    </p>
                  </div>
                )}

                {/* icons */}
                {/* {item.description ? (
                  <div
                    className={`my-0 px-4 pb-2 ${styleEnd(
                      "m",
                      3
                    )} text-decoration-none text-dark`}
                    style={{
                      lineHeight: 1.5,
                      fontSize: 16,
                    }}
                    // to={`/taskDetails/${item.id}`}
                  >
                    {item.description}
                  </div>
                ) : null} */}

                <div
                  className={`d-flex py-2 px-3 mb-2 text-decoration-none text-dark ${styleStart(
                    "m",
                    2
                  )}`}
                  style={{
                    backgroundColor: "#F2F2F2",
                    width: 140,
                    height: 40,
                    borderRadius: 10,
                  }}
                >
                  <li
                    className="d-flex"
                    style={{
                      position: "relative",
                      left: "-45% !important",
                      top: "-185% !important",
                      position: "absolute",
                      width: "inherit",
                    }}
                    data-tip
                    data-for={customStyle(`liMembers-${item.id}`)}
                  >
                    <ReactTooltip
                      id={customStyle(`liMembers-${item.id}`)}
                      type="info"
                      effect="solid"
                      place={"top"}
                      backgroundColor="#12AAC4"
                      arrowColor="#12AAC4"
                    >
                      <span>
                        {item?.members?.length ? (
                          item?.members?.map((item, index) => {
                            return (
                              <div>
                                {item.memberName}
                                <br />
                              </div>
                            );
                          })
                        ) : (
                          <></>
                        )}
                      </span>
                    </ReactTooltip>
                    <div
                      className={`d-flex justify-content-center align-items-center ${styleEnd(
                        "m",
                        2
                      )}`}
                      style={{
                        border: "1px solid #1A73E8",
                        backgroundColor: "#1A73E8",
                        color: "white",
                        borderRadius: "50%",
                        width: 24,
                        height: 24,
                        fontSize: 12,
                      }}
                    >
                      {item?.members?.length ?? 0}
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                      <p className="my-0">
                        {item?.members?.length > 1 ? Lang.Members : Lang.Member}
                      </p>
                    </div>
                  </li>
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
  } else {
    return <div></div>;
  }
};

export default NotifIcationCard;
